import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'welcome-fail',
    templateUrl: 'welcome-fail.component.html'
})
export class WelcomeFailComponent implements OnInit {

    constructor(private route: ActivatedRoute, private translate: TranslateService) {
    }

    ngOnInit(): void {
        this.route.params.subscribe( params => {
            var language : string = params['language'];
            if (language !== null && language !== '') {
                this.translate.setDefaultLang(language.toLowerCase());
            }
        });
    }
}